import axiosInstance from "./axiosInstance";

export const getClientLogo = async () => {
    try {
        const response = await axiosInstance.get("/public/clientLogo", {
            headers: { authType: "PreLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to fetch client logo");
    }
};

export const getClientLogoById = async (id) => {
    try {
        const response = await axiosInstance.get(`/clientlogo/${id}`, {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to fetch client logo item");
    }
};

export const createClientLogo = async (formData) => {
    try {
        const response = await axiosInstance.post("/clientlogo", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                authType: "PostLogin",
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to create client logo");
    }
};

export const updateClientLogo = async (id, formData) => {
    try {
        const response = await axiosInstance.put(`/clientlogo/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                authType: "PostLogin",
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to update client logo");
    }
};

export const deleteClientLogo = async (id) => {
    try {
        const response = await axiosInstance.delete(`/clientLogodel/${id}`, {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to delete client logo");
    }
};